export default __webpack_public_path__ + "static/media/digital-prototypes.a23c7eed.svg";